{
	"watchList": {
		"ticker": "Тикер",
		"company": "Компания",
		"price": "Цена",
		"watchListChangeColumnDollar": "Изм. $",
		"watchListChangeColumnPercent": "Изм. %",
		"actionsColumn": "Действия",
		"empty": "Вы ничего не добавили в избранное",
		"actions": {
			"getFail": "Не удалось получить список избранного",
			"deleteSuccess": "{{symbol}} удален из избранного",
			"deleteFail": "Не удалось удалить {{symbol}} из избранного",
			"addSuccess": "{{symbol}} добавлен в избранное",
			"addFail": "Не удалось добавить {{symbol}} в избранное",
			"delete": "Удалить"
		},
		"addStocks": "Добавить акции"
	}
}
